/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable default-case */
/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { toast } from "react-toastify";
import Skeleton from "@mui/material/Skeleton";
import CircularProgress from "@mui/material/CircularProgress";
import { useQueryClient } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";

import { getEtiquetas } from "services/api/AppWeb_Lead/listar-etiquetas";
import {
  postEtiquetaLead,
  postEtiquetaLeadMultiple,
} from "services/api/AppWeb_Lead/alterar-etiqueta-lead";
import { postProdutosLeadMultiple } from "services/api/AppWeb_Lead/alterar-produtos-lead";
import { useListarEmpreendimentos2 } from "services/api/AppWeb_Empreendimento2/empreendimentos2";
import { useContatosWA } from "services/api/AppWeb_WhatsApp/useWhatsAppContatos";
import { ContatoWA } from "services/api/AppWeb_WhatsApp/types";
import { useWhatsAppStatus } from "services/api/AppWeb_WhatsApp/useWhatsAppStatus";
import { useWhatsAppHub } from "services/api/AppWeb_WhatsApp/useWhatsAppHub";
import { handleWhatsAppHubPayload } from "services/api/AppWeb_WhatsApp/whatsAppHubEvents";
import { useMarcarLido } from "services/api/AppWeb_WhatsApp/useWhatsAppConversas";
import { getCurrentToken } from "hooks/useRefreshToken";

import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../../utils/leadsWebEnviroment";
import AtualizarLeadModal from "../../../../components/AtualizarLeadModal";
import EnviarWhatsAppModal from "../../../../components/EnviarWhatsAppModal";
import { ObservacoesIcon } from "./components/ObservacoesIcon";

import { Context } from "../../../../context/Context";
import { Lead } from "../../../../interfaces";
import { AuthState } from "../../../../store/ducks/auth/types";

import {
  INITIAL_FILTERS,
  formatPhoneNumber,
  getTotalItensRetorno,
} from "./constants";
import { useColumnConfig } from "./hooks/useColumnConfig";
import { useCheckSelection } from "./hooks/useCheckSelection";
import { useTableDialogs } from "./hooks/useTableDialogs";

import { TableHeader } from "./components/TableHeader";
import { TableBody } from "./components/TableBody";
import { TablePagination } from "./components/TablePagination";
import { ColumnSelector } from "./components/ColumnSelector";
import {
  ActionsMenu,
  CheckedActionsMenu,
  EtiquetaMenu,
} from "./components/Menus";
import { Dialogs } from "./components/Dialogs";
import { TagsMultipleContent } from "./components/TagsMultipleContent";
import { ProdutosMultipleContent } from "./components/ProdutosMultipleContent";

import { HeaderTableLeads } from "../headerTableLeads";
import { SkelletonTableGrid } from "../headerTableLeads/skelleton";
import FiltersContent from "../filtersContent";
import TableSkeleton from "../tableSkeleton";
import { KanbanView } from "../kanbanView";
import * as Styles from "./styles";

interface Props {
  leads: Array<Lead>;
  loading?: boolean;
  /** true em qualquer busca, inclusive refetch com dados já em tela */
  refetching?: boolean;
  isShared: boolean;
  requestLeads: Function;
  totalPages: number;
  totalItems: number;
  currentPage: number;
  filtersCount: any;
  onHandleExcel: () => void;
  isLoadingExcel: boolean;
  apiColumns?: string[];
}

interface Option {
  label: string;
  value: string;
}

export function TableGrid(props: Props) {
  const list = props.leads ?? [];
  const queryClient = useQueryClient();

  // Skeleton só na primeira carga; nas seguintes (aplicar filtro, buscar,
  // paginar) mostramos um overlay sobre a tabela já renderizada.
  const isRefetching = Boolean(props.refetching) && !props.loading;

  const { codigoCargo2013, usuarioGerenteOnline } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  // --- Hooks ---
  const columnConfig = useColumnConfig(
    codigoCargo2013,
    props.apiColumns,
    usuarioGerenteOnline
  );
  const selection = useCheckSelection(props.leads);
  const dialogs = useTableDialogs();

  // Corretor dono dos leads listados. Ao transferir toda a carteira nenhum id
  // de lead é enviado, então a API precisa dele para saber de onde buscá-los.
  // Só existe origem quando a listagem inteira é de um único corretor (carteira
  // própria, ou filtrada por um responsável); com vários, a origem é ambígua.
  const idCorretorOrigem = useMemo(() => {
    const origens = list.map((item) => item.idCorretorLead);
    const primeira = origens[0];
    return primeira && origens.every((id) => id === primeira)
      ? primeira
      : undefined;
  }, [list]);

  // --- Context & Data ---
  const { filters, setFilters } = useContext(Context);
  const { data: tags, refetch: refetchEtiquetas } = getEtiquetas();
  const { data: empreendimentos } = useListarEmpreendimentos2(true);
  const { data: whatsContatos = [] } = useContatosWA();
  const { data: whatsStatusData } = useWhatsAppStatus();
  const marcarLido = useMarcarLido();
  const isWhatsConnected = whatsStatusData?.data?.conectado === true;
  const handleHubMensagem = useCallback(
    (payload: any) => {
      handleWhatsAppHubPayload({
        queryClient,
        payload,
      });
    },
    [queryClient]
  );
  useWhatsAppHub(
    isWhatsConnected ? getCurrentToken() || "" : "",
    handleHubMensagem
  );

  // --- Local State ---
  const [viewMode, setViewMode] = useState<"lista" | "funil">(
    filters?.TipoVisualizacao === 2 ? "funil" : "lista"
  );
  const [generalSearch, setGeneralSearch] = useState<string>(
    filters?.paginationParams?.PalavrasChave
  );
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [anchorEl2, setAnchorEl2] = useState<HTMLElement | null>(null);
  const [anchorElEtiqueta, setAnchorElEtiqueta] = useState<HTMLElement | null>(
    null
  );
  const [tempLeadEtiqueta, setTempLeadEtiqueta] = useState<string | null>(null);
  const [anchorLead, setAnchorLead] = useState("");
  const [anchorLeadCorretor, setAnchorLeadCorretor] = useState("");
  const [anchorNomeLead, setAnchorNomeLead] = useState("");
  const [anchorEtapa, setAnchorEtapa] = useState({ label: "", value: "" });
  const [anchorSubEtapa, setAnchorSubEtapa] = useState({
    label: "",
    value: "",
  });
  const [anchorProdutos, setAnchorProdutos] = useState<
    Array<{ id: string; nome: string }>
  >([]);
  const [isLoadingTagsMultiple, setIsLoadingTagsMultiple] = useState(false);
  const [isLoadingProdutosMultiple, setIsLoadingProdutosMultiple] =
    useState(false);
  const [selectedProdutos, setSelectedProdutos] = useState<Option[]>([]);
  const [obsLeadData, setObsLeadData] = useState({
    idLead: "",
    idLeadCorretor: "",
    observacoes: "",
  });
  const unreadByLeadRef = useRef<Record<string, number>>({});

  useEffect(() => {
    if (filters?.paginationParams?.PalavrasChave?.length > 2) {
      setGeneralSearch(filters?.paginationParams?.PalavrasChave);
    }
  }, []);

  const playWhatsAppNotificationSound = useCallback(() => {
    try {
      const AudioCtx =
        window.AudioContext ||
        (window as Window & { webkitAudioContext?: typeof AudioContext })
          .webkitAudioContext;
      if (!AudioCtx) return;

      const ctx = new AudioCtx();
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.type = "sine";
      oscillator.frequency.value = 880;
      gain.gain.value = 0.04;

      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start();
      oscillator.stop(ctx.currentTime + 0.14);

      oscillator.onended = () => {
        ctx.close();
      };
    } catch {
      // silêncio em navegadores sem permissão/autoplay
    }
  }, []);

  useEffect(() => {
    if (!isWhatsConnected) {
      unreadByLeadRef.current = {};
      return;
    }

    const nextUnreadByLead = whatsContatos.reduce((acc, contato) => {
      const id =
        contato.leadCorretorId || contato.rowKey || contato.id || undefined;
      if (id) acc[id] = contato.unreadCount || 0;
      return acc;
    }, {} as Record<string, number>);

    const prevUnreadByLead = unreadByLeadRef.current;
    if (Object.keys(prevUnreadByLead).length > 0) {
      const hasIncrease = Object.entries(nextUnreadByLead).some(
        ([leadId, unreadCount]) => {
          const prevUnread = prevUnreadByLead[leadId] || 0;
          const isOpenedLead =
            dialogs.whatsAppOpen &&
            dialogs.whatsAppLead?.idLeadCorretor === leadId;
          return unreadCount > prevUnread && !isOpenedLead;
        }
      );

      if (hasIncrease) {
        playWhatsAppNotificationSound();
      }
    }

    unreadByLeadRef.current = nextUnreadByLead;
  }, [
    whatsContatos,
    isWhatsConnected,
    dialogs.whatsAppOpen,
    dialogs.whatsAppLead?.idLeadCorretor,
    playWhatsAppNotificationSound,
  ]);

  const normalizePhone = (value?: string | null) =>
    (value || "").replace(/\D/g, "");

  // Monta o link wa.me com o número exatamente como vem da API (já inclui DDI).
  const buildWaMeLink = (phone?: string | null) => {
    const digits = normalizePhone(phone);
    if (!digits) return "";
    return `https://wa.me/${digits}`;
  };

  const getLeadPrimaryPhone = (item: Lead) => {
    const phones = [item.telefone1, item.telefone2, item.telefone3];
    return phones[(item.codigoTelefonePrincipal || 1) - 1] || item.telefone1;
  };

  const findContatoByLead = (item: Lead) => {
    const byLeadId = whatsContatos.find(
      (c) =>
        c.leadCorretorId === item.idLeadCorretor ||
        c.rowKey === item.idLeadCorretor ||
        c.id === item.idLeadCorretor
    );
    if (byLeadId) return byLeadId;

    const numeroLead = normalizePhone(getLeadPrimaryPhone(item) || "");
    if (!numeroLead) return undefined;

    return whatsContatos.find((c) => {
      const numeroContato = normalizePhone(c.telefone);
      if (!numeroContato) return false;
      return (
        numeroContato === numeroLead ||
        numeroContato.endsWith(numeroLead) ||
        numeroLead.endsWith(numeroContato)
      );
    });
  };

  const getLeadWhatsUnreadCount = (item: Lead) =>
    findContatoByLead(item)?.unreadCount || 0;

  // --- Handlers ---
  const handleClick = (
    event: any,
    idLead: string,
    idLeadCorretor: string,
    nomeLead: string
  ) => {
    setAnchorEl(event.currentTarget);
    setAnchorLead(idLead);
    setAnchorLeadCorretor(idLeadCorretor);
    setAnchorNomeLead(nomeLead);
  };

  const handleEtiqueta = (event: any, idLeadCorretor: string) => {
    setAnchorElEtiqueta(event.currentTarget);
    setTempLeadEtiqueta(idLeadCorretor);
  };

  const handleAlterarEtiqueta = (idEtiqueta: string) => {
    postEtiquetaLead({
      idLeadCorretor: tempLeadEtiqueta as string,
      idEtiqueta,
    })
      .then(({ success, data }) => {
        if (success) {
          toast.success(data);
          props.requestLeads();
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erro ao alterar etiqueta");
      });
  };

  const handleAlterarEtiquetaMultiple = async (idEtiqueta: string) => {
    if (selection.checked.length === 0) {
      toast.warning("Selecione ao menos um lead para prosseguir com a ação!");
      return;
    }
    if (isLoadingTagsMultiple) return;

    const idsLeadCorretor = selection.checked.map(
      (item: any) => item.idLeadCorretor
    );
    setIsLoadingTagsMultiple(true);

    try {
      const result = await postEtiquetaLeadMultiple({
        idsLeadCorretor,
        idEtiqueta,
      });
      if (result?.success) {
        toast.success(
          `Etiqueta aplicada com sucesso em ${selection.checked.length} lead(s)!`
        );
        props.requestLeads();
        dialogs.setTagsMultipleOpen(false);
        selection.resetSelection();
      } else {
        throw new Error(result?.message || "Erro ao aplicar etiqueta");
      }
    } catch (err: any) {
      console.error(err);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Erro ao alterar etiquetas"
      );
    } finally {
      setIsLoadingTagsMultiple(false);
    }
  };

  const handleAlterarProdutosMultiple = async () => {
    if (selection.checked.length === 0) {
      toast.warning("Selecione ao menos um lead para prosseguir com a ação!");
      return;
    }
    if (selectedProdutos.length === 0) {
      toast.warning("Selecione ao menos um produto!");
      return;
    }
    if (isLoadingProdutosMultiple) return;

    const idsLeadCorretor = selection.checked.map(
      (item: any) => item.idLeadCorretor
    );
    setIsLoadingProdutosMultiple(true);

    try {
      const result = await postProdutosLeadMultiple({
        idsLeadCorretor,
        idsEmpreendimentos: selectedProdutos.map((p) => p.value),
      });
      if (result?.success) {
        toast.success(
          `Produtos aplicados com sucesso em ${selection.checked.length} lead(s)!`
        );
        props.requestLeads();
        dialogs.setProdutosMultipleOpen(false);
        setSelectedProdutos([]);
        selection.resetSelection();
      } else {
        throw new Error(result?.message || "Erro ao aplicar produtos");
      }
    } catch (err: any) {
      console.error(err);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Erro ao alterar produtos"
      );
    } finally {
      setIsLoadingProdutosMultiple(false);
    }
  };

  const handleClearFilter = () => {
    setFilters((prev: any) => ({
      ...INITIAL_FILTERS,
      TipoVisualizacao: prev?.TipoVisualizacao,
      paginationParams: {
        ...INITIAL_FILTERS.paginationParams,
        TotalItensRetorno: getTotalItensRetorno(prev),
      },
    }));
    props.requestLeads();
  };

  const handleEtapaClick = (item: Lead) => {
    dialogs.setEtapasOpen(true);
    setAnchorLeadCorretor(item.idLeadCorretor);
    setAnchorLead(item.idLead);
    setAnchorSubEtapa({
      label: item.subEtapaFunil,
      value: item.idSubEtapaFunil,
    });
    setAnchorEtapa({ label: item.etapaFunil, value: item.idEtapaFunil });
  };

  const handleProdutoClick = (item: Lead) => {
    dialogs.setProdutosOpen(true);
    setAnchorLeadCorretor(item.idLeadCorretor);
    setAnchorProdutos(
      item?.empreendimentos?.map((emp: any) => ({
        id: emp.id,
        nome: emp.nome,
      })) || []
    );
  };

  const handleUpdateClick = (leadId: string) => {
    dialogs.setSelectedLeadId(leadId);
    dialogs.setOpenAtualizarModal(true);
  };

  const handleObsClick = (item: Lead) => {
    setObsLeadData({
      idLead: item.idLead,
      idLeadCorretor: item.idLeadCorretor,
      observacoes: item.observacoes || "",
    });
    dialogs.setOpenObservacoesModal(true);
  };

  const copyPhoneToClipboard = (item: Lead) => {
    const phonePrincipal = getLeadPrimaryPhone(item);
    if (!phonePrincipal) {
      toast.info("Lead sem telefone para copiar.");
      return;
    }
    const formatted = formatPhoneNumber(phonePrincipal) || phonePrincipal;
    navigator.clipboard
      ?.writeText(formatted)
      .then(() => toast.success(`Número ${formatted} copiado`))
      .catch(() => toast.error("Não foi possível copiar o número."));
  };

  // Chamado pelo CLICK NA LABEL DO TELEFONE — sempre copia, independente do
  // estado da conexão. Também é o caminho quando o WhatsApp está desconectado.
  const handleWhatsAppCopyPhone = (item: Lead) => {
    copyPhoneToClipboard(item);
  };

  // Chamado pelo CLICK NO ÝCONE — abre o modal se conectado; se não estiver
  // conectado, redireciona para o WhatsApp externo (wa.me/numero).
  const handleWhatsAppClick = (item: Lead) => {
    const phonePrincipal = getLeadPrimaryPhone(item);

    if (!isWhatsConnected) {
      const waMeLink = buildWaMeLink(phonePrincipal);
      if (!waMeLink) {
        toast.info("Lead sem telefone para abrir o WhatsApp.");
        return;
      }
      window.open(waMeLink, "_blank", "noopener,noreferrer");
      return;
    }

    const contatoVinculado = findContatoByLead(item);
    const contatoLeadId =
      contatoVinculado?.leadCorretorId ||
      contatoVinculado?.rowKey ||
      contatoVinculado?.id ||
      item.idLeadCorretor;
    if (contatoLeadId) {
      marcarLido(contatoLeadId);
      queryClient.setQueryData<ContatoWA[]>(["contatos-wa"], (prev) =>
        prev?.map((contato) => {
          const id =
            contato.leadCorretorId || contato.rowKey || contato.id || "";
          return id === contatoLeadId
            ? { ...contato, unreadCount: 0 }
            : contato;
        })
      );
    }

    dialogs.setWhatsAppLead({
      nome: item.nome,
      telefone: phonePrincipal || "",
      idLeadCorretor: item.idLeadCorretor,
      fotoUrl: contatoVinculado?.fotoUrl || "",
    });
    dialogs.setWhatsAppOpen(true);
  };

  const whatsAppMassContacts = useMemo<ContatoWA[]>(
    () =>
      selection.checked.map((checkedLead) => {
        const leadData = list.find(
          (lead) =>
            lead.idLeadCorretor === checkedLead.idLeadCorretor ||
            lead.idLead === checkedLead.idLead
        );

        const phones = [
          leadData?.telefone1,
          leadData?.telefone2,
          leadData?.telefone3,
        ];
        const phonePrincipal =
          phones[((leadData?.codigoTelefonePrincipal || 1) - 1) as 0 | 1 | 2] ||
          leadData?.telefone1 ||
          leadData?.telefone2 ||
          leadData?.telefone3 ||
          "";

        return {
          id: checkedLead.idLeadCorretor,
          rowKey: checkedLead.idLeadCorretor,
          leadCorretorId: checkedLead.idLeadCorretor,
          corretorId:
            checkedLead.idCorretorLead || leadData?.idCorretorLead || "",
          telefone: phonePrincipal,
          nome: leadData?.nome || phonePrincipal || "Lead sem nome",
          fotoUrl: leadData?.urlFotoUsuarioCorretor,
          ultimaMensagem: "",
          ultimaMensagemTipo: "",
          ultimaMensagemFromMe: false,
          ultimaMensagemStatus: "",
          unreadCount: 0,
          totalMensagens: 0,
          ultimaAtividade:
            leadData?.dataUltimaAtualizacao || leadData?.dataCriacao || "",
          primeiraMensagem:
            leadData?.dataCriacao || leadData?.dataUltimaAtualizacao || "",
          ativo: true,
        };
      }),
    [selection.checked, list]
  );

  const handleWhatsAppMassClick = () => {
    dialogs.setWhatsAppMassOpen(true);
  };

  const handleObservacoesSubmit = async (observacaoLead: string) => {
    const ALTERAR_OBSERVACAO = `${leadsWebEnviroment}/app-web/leads/alterar-observacao-lead/v1/${obsLeadData.idLeadCorretor}`;
    await instance.put(ALTERAR_OBSERVACAO, {
      idLead: obsLeadData.idLead,
      observacaoLead,
      OrigemCarteira: false,
    });
    toast.success("A observação do lead foi alterada com sucesso");
  };

  // --- Render ---
  return (
    <Styles.TableContainer>
      {/* Header / Skeleton */}
      {props.loading ? (
        <SkelletonTableGrid />
      ) : (
        <>
          <HeaderTableLeads
            searchBarValue={generalSearch}
            onChangeSearchBarValue={(event: any) => setGeneralSearch(event)}
            setFilterFunction={() =>
              setFilters({
                ...filters,
                paginationParams: {
                  PalavrasChave: generalSearch,
                  PaginaAtual: 1,
                  TotalItensRetorno: getTotalItensRetorno(filters),
                  OrdenarPorOrdemAlfabetica: "",
                },
              })
            }
            clearFilter={handleClearFilter}
            isShared={props.isShared}
            filtersCount={props.filtersCount}
            handleFilterOpen={() =>
              dialogs.setFiltersOpen(!dialogs.filtersOpen)
            }
            handleTagsOpen={() => dialogs.setTagsOpen(!dialogs.tagsOpen)}
            handleOpenCols={columnConfig.open}
            handleClick2={(event: any) => setAnchorEl2(event.currentTarget)}
            handleTransfer={() => {
              if (usuarioGerenteOnline) return;
              if (selection.checked.length > 0) {
                dialogs.setTransferMultipleAdmin(
                  !dialogs.transferMultipleAdmin
                );
                setAnchorEl2(null);
              } else {
                toast.warning(
                  "Selecione ao menos um lead para prosseguir com a ação!"
                );
              }
            }}
            handleCompartilhar={() => {
              if (usuarioGerenteOnline) return;
              if (selection.checked.length > 0) {
                dialogs.setCompartilharMultipleAdmin(
                  !dialogs.compartilharMultipleAdmin
                );
                setAnchorEl2(null);
              } else {
                toast.warning(
                  "Selecione ao menos um lead para prosseguir com a ação!"
                );
              }
            }}
            handleExcel={() => props.onHandleExcel()}
            isLoadingExcel={props?.isLoadingExcel}
            viewMode={viewMode}
            onViewModeChange={(mode: "lista" | "funil") => {
              setViewMode(mode);
              setFilters((prev: any) => ({
                ...prev,
                TipoVisualizacao: mode === "funil" ? 2 : 1,
              }));
            }}
          />

          <ColumnSelector
            anchorEl={columnConfig.anchorEl}
            isOpen={columnConfig.isOpen}
            onClose={columnConfig.close}
            tempColumns={columnConfig.tempColumns}
            codigoCargo={codigoCargo2013}
            usuarioGerenteOnline={usuarioGerenteOnline}
            onToggle={columnConfig.toggleTempColumn}
            onReset={columnConfig.reset}
            onSave={columnConfig.save}
          />
        </>
      )}

      {/* Table / Kanban */}
      <Styles.LoadingArea>
        {isRefetching && (
          <Styles.LoadingOverlay>
            <Styles.LoadingOverlayContent>
              <CircularProgress size={18} thickness={5} />
            </Styles.LoadingOverlayContent>
          </Styles.LoadingOverlay>
        )}
        {props.loading ? (
          <TableSkeleton />
        ) : viewMode === "funil" ? (
          <KanbanView
            filters={filters}
            isShared={props.isShared}
            requestLeads={props.requestLeads}
            onMenuClick={(e, idLead, idLeadCorretor, nomeLead) => {
              setAnchorEl(e.currentTarget as HTMLElement);
              setAnchorLead(idLead);
              setAnchorLeadCorretor(idLeadCorretor);
              setAnchorNomeLead(nomeLead);
            }}
            onWhatsAppClick={handleWhatsAppClick}
            onWhatsAppCopyPhone={handleWhatsAppCopyPhone}
            isWhatsConnected={isWhatsConnected}
            getWhatsAppUnreadCount={getLeadWhatsUnreadCount}
          />
        ) : (
          <>
            {list?.length > 0 ? (
              <Styles.TableWrapper>
                {selection.active &&
                  props.totalItems > list.length &&
                  !usuarioGerenteOnline &&
                  !!idCorretorOrigem && (
                    <Styles.SelectAllBanner>
                      {selection.allPagesSelected ? (
                        <>
                          <span>
                            Todos os {props.totalItems} leads da carteira estão
                            selecionados.
                          </span>
                          <Styles.SelectAllBannerButton
                            type="button"
                            onClick={() => selection.clearAllPages()}
                          >
                            Limpar seleção de todas as páginas
                          </Styles.SelectAllBannerButton>
                        </>
                      ) : (
                        <>
                          <span>
                            Os {list.length} leads desta página estão
                            selecionados.
                          </span>
                          <Styles.SelectAllBannerButton
                            type="button"
                            onClick={() => selection.selectAllPages()}
                          >
                            Selecionar todos os {props.totalItems} leads da
                            carteira
                          </Styles.SelectAllBannerButton>
                        </>
                      )}
                    </Styles.SelectAllBanner>
                  )}
                <Styles.Table style={{ width: "100%" }}>
                  <TableHeader
                    visibleColumns={columnConfig.visibleColumns}
                    codigoCargo={codigoCargo2013}
                    usuarioGerenteOnline={usuarioGerenteOnline}
                    active={selection.active}
                    onCheckAll={selection.handleCheckAll}
                    isShared={props.isShared}
                  />
                  <TableBody
                    leads={list}
                    visibleColumns={columnConfig.visibleColumns}
                    codigoCargo={codigoCargo2013}
                    usuarioGerenteOnline={usuarioGerenteOnline}
                    isShared={props.isShared}
                    checkedState={selection.checkedState}
                    onCheck={selection.addRemoveCheck}
                    onUpdateClick={handleUpdateClick}
                    onMenuClick={handleClick}
                    onEtiquetaClick={handleEtiqueta}
                    onEtapaClick={handleEtapaClick}
                    onProdutoClick={handleProdutoClick}
                    onObsClick={handleObsClick}
                    onWhatsAppClick={handleWhatsAppClick}
                    onWhatsAppCopyPhone={handleWhatsAppCopyPhone}
                    isWhatsConnected={isWhatsConnected}
                    getWhatsAppUnreadCount={getLeadWhatsUnreadCount}
                  />
                </Styles.Table>
              </Styles.TableWrapper>
            ) : (
              <Styles.NotFoundText>Nenhum Lead Encontrado</Styles.NotFoundText>
            )}
          </>
        )}

        {/* Pagination (hidden in Funil mode) */}
        {viewMode === "lista" &&
          (props.loading ? (
            <Styles.Row
              style={{ marginTop: 30, justifyContent: "space-between" }}
            >
              <Skeleton variant="rectangular" width={168} height={26} />
              <Skeleton variant="rectangular" width={181} height={26} />
            </Styles.Row>
          ) : (
            <TablePagination
              totalPages={props.totalPages}
              totalItems={props.totalItems}
            />
          ))}
      </Styles.LoadingArea>

      {/* Context Menus */}
      <CheckedActionsMenu
        anchorEl={anchorEl2}
        open={Boolean(anchorEl2)}
        onClose={() => setAnchorEl2(null)}
        checkedCount={selection.checked.length}
        disableTransferShare={usuarioGerenteOnline}
        onTransfer={() =>
          dialogs.setTransferMultiple(!dialogs.transferMultiple)
        }
        onShare={() => dialogs.setSharedMultiple(!dialogs.sharedMultiple)}
        onAlterarEtiquetas={() => dialogs.setTagsMultipleOpen(true)}
        onAlterarProdutos={() => dialogs.setProdutosMultipleOpen(true)}
        onEnviarWhatsAppMassa={handleWhatsAppMassClick}
        showEnviarWhatsAppMassa={isWhatsConnected}
      />

      <ActionsMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        isShared={props.isShared}
        disableTransferShare={usuarioGerenteOnline}
        onCreateTask={() => dialogs.setNewTask(!dialogs.newTask)}
        onHistoric={() => dialogs.setHistoric(!dialogs.historic)}
        onTransfer={() => dialogs.setTransfer(!dialogs.transfer)}
        onShare={() => dialogs.setShared(!dialogs.shared)}
        onDisqualify={() => dialogs.setDisqualify(!dialogs.disqualify)}
      />

      <EtiquetaMenu
        anchorEl={anchorElEtiqueta}
        open={Boolean(anchorElEtiqueta)}
        onClose={() => {
          setAnchorElEtiqueta(null);
          setTempLeadEtiqueta(null);
        }}
        tags={tags}
        onAlterarEtiqueta={handleAlterarEtiqueta}
      />

      {/* Filters Drawer */}
      <Styles.SwipeableDrawer
        open={dialogs.filtersOpen}
        anchor="right"
        onClose={() => dialogs.setFiltersOpen(false)}
        onOpen={() => dialogs.setFiltersOpen(true)}
      >
        <FiltersContent
          codigoCargo2013={codigoCargo2013}
          isOpen={dialogs.filtersOpen}
        />
      </Styles.SwipeableDrawer>

      {/* All Dialogs */}
      <Dialogs
        anchorLead={anchorLead}
        anchorLeadCorretor={anchorLeadCorretor}
        anchorNomeLead={anchorNomeLead}
        anchorEtapa={anchorEtapa}
        anchorSubEtapa={anchorSubEtapa}
        anchorProdutos={anchorProdutos}
        checked={selection.checked}
        allPagesSelected={selection.allPagesSelected}
        idCorretorOrigem={idCorretorOrigem}
        requestLeads={props.requestLeads}
        newTask={dialogs.newTask}
        setNewTask={dialogs.setNewTask}
        concludeTask={dialogs.concludeTask}
        setConcludeTask={dialogs.setConcludeTask}
        itemConclude={dialogs.itemConclude}
        disqualify={dialogs.disqualify}
        setDisqualify={dialogs.setDisqualify}
        shared={dialogs.shared}
        setShared={dialogs.setShared}
        transfer={dialogs.transfer}
        setTransfer={dialogs.setTransfer}
        sharedMultiple={dialogs.sharedMultiple}
        setSharedMultiple={dialogs.setSharedMultiple}
        transferMultiple={dialogs.transferMultiple}
        setTransferMultiple={dialogs.setTransferMultiple}
        transferMultipleAdmin={dialogs.transferMultipleAdmin}
        setTransferMultipleAdmin={dialogs.setTransferMultipleAdmin}
        compartilharMultipleAdmin={dialogs.compartilharMultipleAdmin}
        setCompartilharMultipleAdmin={dialogs.setCompartilharMultipleAdmin}
        historic={dialogs.historic}
        setHistoric={dialogs.setHistoric}
        openAtualizarModal={dialogs.openAtualizarModal}
        setOpenAtualizarModal={dialogs.setOpenAtualizarModal}
        selectedLeadId={dialogs.selectedLeadId}
        tagsOpen={dialogs.tagsOpen}
        setTagsOpen={dialogs.setTagsOpen}
        etapasOpen={dialogs.etapasOpen}
        setEtapasOpen={dialogs.setEtapasOpen}
        produtosOpen={dialogs.produtosOpen}
        setProdutosOpen={dialogs.setProdutosOpen}
        tags={tags}
        refetchEtiquetas={refetchEtiquetas}
        tagsMultipleOpen={dialogs.tagsMultipleOpen}
        setTagsMultipleOpen={dialogs.setTagsMultipleOpen}
        tagsMultipleContent={
          <TagsMultipleContent
            checkedCount={selection.checked.length}
            isLoading={isLoadingTagsMultiple}
            tags={tags}
            onAlterarEtiqueta={handleAlterarEtiquetaMultiple}
          />
        }
        produtosMultipleOpen={dialogs.produtosMultipleOpen}
        setProdutosMultipleOpen={dialogs.setProdutosMultipleOpen}
        produtosMultipleContent={
          <ProdutosMultipleContent
            checkedCount={selection.checked.length}
            isLoading={isLoadingProdutosMultiple}
            empreendimentos={empreendimentos}
            selectedProdutos={selectedProdutos}
            onSelectedProdutosChange={setSelectedProdutos}
            onCancel={() => {
              dialogs.setProdutosMultipleOpen(false);
              setSelectedProdutos([]);
            }}
            onApply={handleAlterarProdutosMultiple}
          />
        }
        onSaveProdutosMultiple={handleAlterarProdutosMultiple}
        onCloseProdutosMultiple={() => {
          dialogs.setProdutosMultipleOpen(false);
          setSelectedProdutos([]);
        }}
        whatsAppMassOpen={dialogs.whatsAppMassOpen}
        setWhatsAppMassOpen={dialogs.setWhatsAppMassOpen}
        whatsAppMassContacts={whatsAppMassContacts}
      />

      {/* Observações Modal */}
      <AtualizarLeadModal
        open={dialogs.openObservacoesModal}
        onClose={() => dialogs.setOpenObservacoesModal(false)}
        idLead365={obsLeadData.idLead}
        title="Observações do Lead"
        icon={<ObservacoesIcon />}
        placeholder="Digite a observação do lead..."
        maxLength={800}
        confirmLabel="Salvar"
        confirmingLabel="Salvando..."
        initialValue={obsLeadData.observacoes}
        onSubmit={handleObservacoesSubmit}
        onSuccess={() => props.requestLeads()}
      />

      {/* Enviar WhatsApp Modal */}
      <EnviarWhatsAppModal
        open={dialogs.whatsAppOpen}
        onClose={() => dialogs.setWhatsAppOpen(false)}
        leadName={dialogs.whatsAppLead?.nome || ""}
        leadPhone={dialogs.whatsAppLead?.telefone || ""}
        idLeadCorretor365={dialogs.whatsAppLead?.idLeadCorretor || ""}
        leadPhotoUrl={dialogs.whatsAppLead?.fotoUrl || ""}
      />
    </Styles.TableContainer>
  );
}
